export const topTabBarpadding = '11.51px 14.16px';
export const helperSideBarWidth = 280;
export const pageSizes = {
    A4: 'A4',
    A3: 'A3',
    A5: 'A5',
    Letter: 'Letter',
    Legal: 'Legal',
    Ledger: 'Ledger',
    B5: 'B5',
    C5: 'C5',
};

export const pageSizesDimensions = {
    [pageSizes.A4]: { width: 499, height: 670 },
    [pageSizes.A3]: { width: 531, height: 750 },
    [pageSizes.A5]: { width: 350, height: 499 },
    [pageSizes.Letter]: { width: 510, height: 680 },
    [pageSizes.Legal]: { width: 440, height: 750 },
    [pageSizes.Ledger]: { width: 900, height: 584 },
    [pageSizes.B5]: { width: 518, height: 726 },
    [pageSizes.C5]: { width: 460, height: 648 },
};
export const STANDARD_PAPER_SIZES_MM = {
    A3: { width: 297, height: 420 },
    A4: { width: 210, height: 297 },
    A5: { width: 148, height: 210 },
    Letter: { width: 215.9, height: 279.4 },
    Legal: { width: 215.9, height: 355.6 },
    Ledger: { width: 431.8, height: 279.4 },
    B5: { width: 176, height: 250 },
    C5: { width: 162, height: 229 },
};

export const CANVAS_SIZE_MODES = {
    preset: 'preset',
    custom: 'custom',
};

export const CUSTOM_CANVAS_PRESET_KEY = 'Custom';
export const MM_TO_PX_RATIO =
    pageSizesDimensions[pageSizes.A4].width / STANDARD_PAPER_SIZES_MM.A4.width;

const MIN_CUSTOM_MM = 10;
const MAX_CUSTOM_MM = 2000;

export const isValidPresetSize = size => Boolean(size && pageSizesDimensions[size]);

export const clampMm = value => {
    const parsed = Number(value);
    if (!Number.isFinite(parsed)) return null;
    const clamped = Math.max(MIN_CUSTOM_MM, Math.min(MAX_CUSTOM_MM, parsed));
    return Number(clamped.toFixed(2));
};

export const mmToPx = mm => {
    const safeMm = clampMm(mm);
    if (!safeMm) return null;
    return Math.round(safeMm * MM_TO_PX_RATIO);
};

const getPresetMmDimensions = preset => STANDARD_PAPER_SIZES_MM[preset] || null;

export const getCanvasSizeLabel = canvasSize => {
    if (!canvasSize) return pageSizes.A4;
    if (canvasSize.mode === CANVAS_SIZE_MODES.custom) {
        return `${canvasSize.widthMm} x ${canvasSize.heightMm} mm`;
    }
    return canvasSize.preset || pageSizes.A4;
};

export const normalizeCanvasSize = (input = null, fallbackPreset = pageSizes.A4) => {
    const fallback = {
        mode: CANVAS_SIZE_MODES.preset,
        preset: fallbackPreset,
        widthPx:
            pageSizesDimensions[fallbackPreset]?.width || pageSizesDimensions[pageSizes.A4].width,
        heightPx:
            pageSizesDimensions[fallbackPreset]?.height || pageSizesDimensions[pageSizes.A4].height,
        widthMm: getPresetMmDimensions(fallbackPreset)?.width || STANDARD_PAPER_SIZES_MM.A4.width,
        heightMm:
            getPresetMmDimensions(fallbackPreset)?.height || STANDARD_PAPER_SIZES_MM.A4.height,
    };

    if (!input) return fallback;

    if (typeof input === 'string' && isValidPresetSize(input)) {
        const mmDims = getPresetMmDimensions(input) || getPresetMmDimensions(fallbackPreset);
        return {
            mode: CANVAS_SIZE_MODES.preset,
            preset: input,
            widthPx: pageSizesDimensions[input].width,
            heightPx: pageSizesDimensions[input].height,
            widthMm: mmDims?.width,
            heightMm: mmDims?.height,
        };
    }

    const mode = input.mode || (isValidPresetSize(input.size) ? CANVAS_SIZE_MODES.preset : null);
    const preset = input.preset || input.size;

    if (mode === CANVAS_SIZE_MODES.preset && isValidPresetSize(preset)) {
        const mmDims = getPresetMmDimensions(preset) || getPresetMmDimensions(fallbackPreset);
        return {
            mode: CANVAS_SIZE_MODES.preset,
            preset,
            widthPx: pageSizesDimensions[preset].width,
            heightPx: pageSizesDimensions[preset].height,
            widthMm: mmDims?.width,
            heightMm: mmDims?.height,
        };
    }

    const widthMm = clampMm(input.widthMm);
    const heightMm = clampMm(input.heightMm);
    const widthPx = mmToPx(widthMm);
    const heightPx = mmToPx(heightMm);

    if (mode === CANVAS_SIZE_MODES.custom && widthPx && heightPx) {
        return {
            mode: CANVAS_SIZE_MODES.custom,
            preset: CUSTOM_CANVAS_PRESET_KEY,
            widthMm,
            heightMm,
            widthPx,
            heightPx,
        };
    }

    return fallback;
};
